// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"login_loginPage__ecptz","formSide":"login_formSide__8tRAY","container":"login_container___HvM1"};